import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { api } from './api';
import {
  RequestLoadDraftsData, ReceiveLoadDraftsData, FailLoadDraftsData
} from './action-types';

export const actionCreators = {
  loadDraftsData: (): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch) => {
      dispatch(new RequestLoadDraftsData());
      try {
        const data = await api.getDraftsData();
        dispatch(new ReceiveLoadDraftsData(data));
      } catch {
        dispatch(new FailLoadDraftsData());
      }
    }
};
